import React from 'react';

import { useProfileState, useProfileActions } from './ProfileContext';
import { updateCurrentUserBiography } from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Textarea from '../../Shared/UI/Textarea/components/Textarea';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const UserBiographyUpdateForm = () => {
  const state = useProfileState();
  const { onResponse, onError, updateNewUserBiography, closeUserBiographyUpdateModal } = useProfileActions();

  const biographyPlaceholder =
    `Add your professional biography here...\n\n` +

    `Example:\n\n` +

    `Dr. You is a Principal Scientist at Example Therapeutics, ` +
    `where they lead cross-functional research teams advancing biologics ` +
    `from early discovery through preclinical development.\n\n` +

    `With over 12 years of experience in protein engineering and ` +
    `translational biology, Dr. You has played a key role in ` +
    `developing next-generation antibody platforms designed to improve ` +
    `therapeutic efficacy and patient outcomes.\n\n` +

    `Their expertise spans high-throughput screening, assay development, ` +
    `and structure-guided drug design, with a strong track record of ` +
    `delivering innovative solutions that have progressed into clinical ` +
    `pipelines.\n\n` +

    `Passionate about mentorship and collaboration, Dr. You partners ` +
    `closely with academic groups, industry stakeholders, and internal R&D ` +
    `colleagues to accelerate discovery.\n\n` +

    `Dr. You holds a Ph.D. in Molecular Biology from Example University ` +
    `and has authored more than 20 peer-reviewed publications and patents.\n\n` +

    `Outside of the lab, they are an advocate for STEM education and enjoy ` +
    `speaking at biotech conferences on the future of biologics and ` +
    `translational science.`;

  const handleSubmit = () => {
    updateCurrentUserBiography({
      onResponse,
      onError,
      body: {
        biography: state?.userBiographyUpdateForm?.biography || '',
        authenticityToken: document.querySelector("meta[name='csrf-token']")?.getAttribute("content")
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Biography" id="biography">
        <Textarea
          rows={12}
          value={state?.userBiographyUpdateForm?.biography || ''}
          onChange={(e) => updateNewUserBiography(e.target.value)}
          placeholder={biographyPlaceholder}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => closeUserBiographyUpdateModal()}
          >
            Cancel
          </Button>
          <Button type="submit">
            Save Update
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default UserBiographyUpdateForm;
